module.exports = __webpack_public_path__ + "img/tree-01-i-trunk.2a41ef7c.png";